import { compose, filter, propEq } from 'ramda';
import { dotPathOr } from 'ramda-extension';

export const selectAllToasts = dotPathOr([], 'toasts.queue');

export const selectToastsByContext = (ctx) =>
  compose(filter(propEq('context', ctx)), selectAllToasts);
